import { createFileRoute } from '@tanstack/react-router'
import { Overview } from '@/components/custom/ui/landing/overview';
import galleryConfig from '@/constant/config/clients/tempula/gallery/gallerycongif';
import HeroSection from "@/components/custom/ui/clients/tempula/booking/heroSection";
import GalleryheroConfig from "@/constant/config/clients/tempula/gallery/galleryheroConfig";
import { Gallery3 } from '@/components/custom/ui/clients/tempula/gallery/gallery3';
import HomestayFooterCmp from '@/components/custom/ui/clients/tempula/homestay/homestayFooter';
import HomestayfooterConfig from '@/constant/config/clients/tempula/homestay/homestayFooterConfig';
import HomenavConfig from '@/constant/config/clients/tempula/homestay/homestayNavConfig';
import HomestayNavbar from '@/components/custom/ui/clients/tempula/homestay/homestayNavbar';



import { SEO, buildPageHead } from '@/constant/config/clients/tempula/seo'

export const Route = createFileRoute('/_clients/tempula/gallery')({
    head: () => buildPageHead(SEO.gallery),
    component: RouteComponent,
})
const overview = [
    ` Explore our gallery and discover beautiful moments from our homestay, where nature, comfort, and unforgettable experiences come together in every frame.
`,
];


function RouteComponent() {
    return (
        <div className="bg-BgGallery">
            <div className="fixed top-0 left-0 w-full z-50">
                <HomestayNavbar {...HomenavConfig} />
            </div>            {/* <Search options={myOptions} onSearch={handleSearch} /> */}
            <HeroSection {...GalleryheroConfig} />
            <Overview overview={overview} />
            <Gallery3  {...galleryConfig} />
            <HomestayFooterCmp {...HomestayfooterConfig} />
        </div>
    )
}
